import React from 'react';

import { TextField } from '@mui/material';
import { GridRenderEditCellParams, useGridApiContext } from '@mui/x-data-grid';

import ConditionValueDatetimeField from '~/components/Common/Elements/ConditionValueDatetimeField';

type Props = GridRenderEditCellParams & {
  isDatetime: boolean;
};

export default function VoucherConditionValueEditCell({ id, field, value, isDatetime }: Props) {
  const apiRef = useGridApiContext();
  if (!isDatetime) {
    return (
      <TextField
        size="small"
        value={value ?? ''}
        onChange={(event) => apiRef.current.setEditCellValue({ id, field, value: event.target.value })}
        fullWidth
        variant="outlined"
      />
    );
  }
  const raw = typeof value === 'string' ? value : String(value ?? '');
  return (
    <ConditionValueDatetimeField
      value={raw}
      onCommit={(iso) => {
        void apiRef.current.setEditCellValue({ id, field, value: iso });
      }}
    />
  );
}
